<template lang="pug">
.crisis-quota
  .module-title
    .bar
    span 危机指标
    el-tooltip(effect="light", placement="bottom-start")
      ._tooltip__content(slot="content")
        p(style="font-weight: bold; font-size: 14px; margin-bottom: 5px") 主流媒体
        p 以媒体影响力为参考标准，选择上百家主流媒体，统计不同危机中参与的主流
        p 媒体数量，求平均值。
        p(
          style="font-weight: bold; font-size: 14px; margin-top: 10px; margin-bottom: 5px"
        ) 微博粉丝数
        p 将微博平台粉丝数按照千万、百万、十万的区间划分，统计不同危机中微博用
        p 户参与的数量，求平均值。
      img(src="../assets/img/question.png", width=14, height=14)
  .data-box
    .data(v-for="(tagList, i) in tags", :key="i")
      .data_li(v-for="tag in tagList", :key="tag.name")
        p.key {{ tag.name }}
        p.value
          el-tooltip(
            effect="light",
            :content="tag.tooltip",
            placement="top-start",
            v-if="tag.tooltip"
          )
            label {{ tag.value }}
              span.avg(v-if="tag.avg") {{ tag.avg }}
          template(v-else)
            label {{ tag.value }}
              span.avg(v-if="tag.avg") {{ tag.avg }}
</template>

<script>
import ModuleTitle from '../EventCenter/ModuleTitle'
export default {
  name: 'CrisisQuota',
  components: {
    ModuleTitle
  },
  props: {
    tags: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.crisis-quota {
  margin-top: 20px;
  // height: 360px;
  background-color: #ffffff;
  border-radius: 4px;
  // margin-top: 20px;
  // margin-left: 10px;
  padding: 14px;

  .module-title {
    display: flex;
    align-items: center;

    .bar {
      width: 4px;
      height: 14px;
      background-color: #f87653;
      border-radius: 2px;
      margin-right: 9px;
    }

    span {
      color: #333;
      font-size: 16px;
    }

    ._tooltip__content {
      padding: 10px;

      ._tooltip__title {
        font-weight: bold;
        margin-bottom: 5px;

        &:last-child {
          margin-top: 10px;
        }
      }
    }

    img {
      margin-left: 3px;
    }
  }

  %label {
    width: 50%;
    display: flex;
    height: 50px;

    .key {
      flex: 160;
      width: 0;
      color: #999;
      background-color: #fcfcfc;
      border-right: 1px solid #f5f5f5;
      border-bottom: 1px solid #f5f5f5;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 20px;
      font-size: 12px;
      overflow: hidden;
      white-space: nowrap;
    }

    .value {
      flex: 140;
      width: 0;
      color: #333;
      border-right: 1px solid #f5f5f5;
      border-bottom: 1px solid #f5f5f5;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 20px;

      .avg {
        color: #999;
      }
    }
  }
  .data-box {
    height: 185px;
    width: 100%;
    display: flex;
    .data {
      flex: 1;
      display: flex;
      align-items: center;
      flex-flow: row wrap;
      margin-top: 20px;
      border-top: 1px solid #f5f5f5;
      border-left: 1px solid #f5f5f5;
      &:nth-child(2) {
        margin-left: 20px;
      }
      .data_li {
        @extend %label;
        width: 100%;
        height: 36px;
        line-height: 36px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventGeneral/CrisisQuota.vue